import { useReports } from "../context/ReportsContext";
import Features from "./Features";
import Eligible from "./Eligible";
import Countdown from "./Countdown";
import MobileInput from "./MobileInput";
import { BROKER_NAME } from "../../../utils/constants";
import ReportsBanner from "../../../images/reports/reports_card.svg"
const LockedReports = () => {
  const { eligibility } = useReports();

  if (!eligibility) return null;

  return (
    <div className="flex flex-col space-y-4">
      <h2 className="text-xl font-semibold text-p300">
        Want expert market insights?
      </h2>
      <p className="text-sm font-medium text-n400">
        👋 Say hello to our expert market analysis!
      </p>
      <img src={ReportsBanner} alt="" />
      <Features />
      <div className="mt-3">
        {eligibility.showUnlock ? (
          <Eligible eligibility={eligibility} />
        ) : BROKER_NAME === "gmail" ? (
          <MobileInput eligibility={eligibility} />
        ) : (
          <Countdown eligibility={eligibility} />
        )}
      </div>
    </div>
  );
};

export default LockedReports;
